import React from "react";
import { useLanguage } from "./Context/LanguageContext";

const LanguageSwitcher = () => {
  const { language, toggleLanguage } = useLanguage();

  return (
    <button onClick={toggleLanguage} className="language-btn">
      <i class="fa-solid fa-globe"></i>
      {language === "en" ? "العربية" : " En"}
    </button>
  );
};

export default LanguageSwitcher;
